// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"LoginNavButtons_mainContainer__3CNzz","content":"LoginNavButtons_content__3e1CI","divider":"LoginNavButtons_divider__3s0X7","link":"LoginNavButtons_link__2X5y1"};